import { formatDateBR } from '@/shared/utils/date-validator'

export default {
  name: 'dicom-plus-soc',
  props: {
    cpf: String,
    renderInDocumentBody: { type: Boolean, default: false },
    selecaoMultipla: { type: Boolean, default: true },
    items: {
      type: Array,
      default: () => []
    },
    total: Number,
    pageCount: Number,
    page: Number,
    pageSize: Number
  },
  data() {
    return {
      localPage: this.page,
      localPageSize: this.pageSize,
      selectedItems: []
    }
  },
  mounted() {
    if (this.renderInDocumentBody) document.body.appendChild(this.$el)
  },
  beforeDestroy() {
    if (this.renderInDocumentBody && this.$el.parentNode) this.$el.parentNode.removeChild(this.$el)
  },
  watch: {
    page(val) {
      this.localPage = val
    },
    pageSize(val) {
      this.localPageSize = val
    },

    items(newItems) {
      if (!Array.isArray(newItems)) return
      const ids = newItems.map((i) => String(i.portalSocID))
      this.selectedItems = this.selectedItems.filter((si) => ids.includes(String(si.portalSocID)))
    }
  },
  methods: {
    isSelected(item) {
      return this.selectedItems.some((si) => String(si.portalSocID) === String(item.portalSocID))
    },
    toggleSelect(item) {
      const idx = this.selectedItems.findIndex((si) => String(si.portalSocID) === String(item.portalSocID))
      if (!this.selecaoMultipla) {
        const fichaJaSelecionada = idx !== -1
        this.selectedItems = fichaJaSelecionada ? [] : [item]
        return
      }
      if (idx === -1) {
        this.selectedItems.push(item)
      } else {
        this.selectedItems.splice(idx, 1)
      }
    },
    confirmarSelecao() {
      this.$emit('selecionar-fichas', this.selectedItems.slice())
    },
    selecionarFicha(id, especialidadeCodigo, especialidadeNome) {
      this.$emit('selecionar-ficha', id, especialidadeCodigo, especialidadeNome)
    },
    goToPage(newPage) {
      if (newPage < 1 || newPage > this.pageCount) return
      this.localPage = newPage
      this.$emit('change-page', newPage, this.localPageSize)
    },
    onPageSizeChange() {
      this.localPage = 1
      this.$emit('change-page', 1, this.localPageSize)
    },
    formatDate(data){
      return formatDateBR(data)
    }
  }
}
